export class VendorItem {
    ID: number;
    FileName: string;
    Name: string;
    IgnoreStatistics: boolean;
    DateTimeCreated: Date;

    public static FixDates(item: VendorItem) {
        item.DateTimeCreated = new Date(item.DateTimeCreated);
    }
}


export class VendorItemArray extends Array<VendorItem> {

    constructor(...items: VendorItem[]) {
        super(...items);
        Object.setPrototypeOf(this, VendorItemArray.prototype);
    }

    public static FixDates(items: VendorItemArray) {
        items.forEach(x => VendorItem.FixDates(x));
    }

}
